/**
 * O filtro da tela de turnos, na URL (p.16): "O estado dos filtros vai para a
 * URL, para o usuário poder salvar e compartilhar a visão." — "me manda os
 * turnos da ESC-002 de agosto" é um link, e não uma sequência de cliques.
 *
 * O mesmo desenho de `validarBuscaDaConciliacao`: só passa o que tem a forma
 * certa, e o resto some em silêncio — um link velho ou digitado errado abre a
 * tela no padrão em vez de quebrar. `apontar` abre o apontamento como página
 * inteira (R01, p.29: mais de 10 campos), e o botão Voltar do navegador fecha.
 */
const FORMATO_DA_DATA = /^\d{4}-\d{2}-\d{2}$/;

/* Forma E dia de verdade: "2026-02-31" tem a forma e não existe, e a tela
   formata a data do filtro — uma data inválida ali derrubaria a página. */
function ehData(valor: unknown): valor is string {
  return (
    typeof valor === 'string' &&
    FORMATO_DA_DATA.test(valor) &&
    !Number.isNaN(new Date(`${valor}T12:00:00`).getTime())
  );
}

export interface BuscaDaOperacao {
  readonly de?: string;
  readonly ate?: string;
  readonly equipamento?: string;
  readonly apontar?: true;
}

export function validarBuscaDaOperacao(entrada: Record<string, unknown>): BuscaDaOperacao {
  const { de, ate, equipamento, apontar } = entrada;
  return {
    ...(ehData(de) ? { de } : {}),
    ...(ehData(ate) ? { ate } : {}),
    ...(typeof equipamento === 'string' && equipamento !== '' ? { equipamento } : {}),
    ...(apontar === true || apontar === 'true' || apontar === 1 || apontar === '1' ? { apontar: true as const } : {}),
  };
}
